import { Skeleton } from './Skeleton';
import './skeleton.css';

type ListSkeletonProps = {
  rows?: number;
};

/** Lignes skeleton pour listes / tableaux en chargement. */
export function ListSkeleton({ rows = 4 }: ListSkeletonProps) {
  return (
    <div className="page-skeleton-list" role="status" aria-label="Chargement">
      {Array.from({ length: rows }, (_, i) => (
        <Skeleton key={i} variant="row" />
      ))}
    </div>
  );
}
